export enum PHONE_NUMBER_STATUS {
    UNVERIFIED = 'unverified',
    PENDING_SMS = 'pending_sms',
    REQUIRED = 'required',
    VERIFIED = 'verified',
}